import { render, staticRenderFns } from "./inquiryVeritas.vue?vue&type=template&id=521c3f40&scoped=true&"
import script from "./inquiryVeritas.vue?vue&type=script&lang=js&"
export * from "./inquiryVeritas.vue?vue&type=script&lang=js&"
import style0 from "./inquiryVeritas.vue?vue&type=style&index=0&id=521c3f40&lang=scss&scoped=true&"
import style1 from "./inquiryVeritas.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./inquiryVeritas.vue?vue&type=style&index=2&id=521c3f40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521c3f40",
  null
  
)

export default component.exports